/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-11 15:36:33
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 18:19:07
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/Info/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { NEW } from 'src/tools/constant';
import { convertDataFromReduxToServer } from '../tools';

import VirtualProductInfo from 'src/pages/ProductEditor/Components/ProductInfo/VirtualProductInfo';
import Status from 'src/pages/ProductEditor/Components/StatusTag/Status';
import SectionHOC from 'src/layout/EditorPageLayout/EditorCollapsePageLayout/SectionHOC';
//import { changeProductStatus } from 'src/pages/ProductEditor/tools/common';
import { store } from 'src/store';
import {
  onProductInfoChange,
  getStatus,
  getBrands,
  getProductInfo,
  getCollapse,
  onCollapseChange,
  EnumCollapseId,
  activeProduct,
  draftProduct,
  archiveProduct,
  validation,
  getState,
  onBrandsAdd,
  onCodesDelete,
  onCodesChange,
  onProductTypeChange,
  getProductType,
} from '../slice';
import { getProductName } from 'src/pages/ProductEditor/VirtualProduct/tools';
import { addBrand as brandReq } from 'src/pages/ProductEditor/tools/commonRequests';
import { EnumIds } from 'src/pages/ProductEditor/VirtualProduct/common';
import { EnumStatus } from 'src/types/common/product';
import { onFinishFailed } from 'src/tools/helper';
import { allFields } from 'src/pages/ProductEditor/VirtualProduct/EditorHOC';
import { timeoutScroll } from 'src/tools/helper';
import { storeResourceNameGenerator } from 'src/tools/getUserInfo';
import {
  EnumCategory,
  EnumSubCategory,
  EnumOperation,
} from 'src/types/common/resources';
import { isUserValid } from 'src/tools/getUserInfo';
import { EPermissionSource } from 'src/types/common/resources';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const VirtualInfo = (props) => {
  const _d = useDispatch();
  const { setShowModal, setModalTitle, setModalContent, disabled } = props;

  const brands = useSelector(getBrands());
  const data = useSelector(getProductInfo());
  const productType = useSelector(getProductType());

  const handleOnBrandAdd = (brand) => {
    brandReq({ name: brand }).then((b) => {
      _d(onBrandsAdd(b));
    });
  };
  const handleOnCodeDelete = (index) => {
    _d(onCodesDelete({ index }));
  };
  const handleOnCodeChange = (e, index) => {
    _d(onCodesChange({ code: e, index }));
  };
  const handleOnInfoChange = (data) => {
    _d(onProductInfoChange(data));
  };
  const handleOnTypeChange = (type) => {
    _d(onProductTypeChange(type));
  };
  return (
    <VirtualProductInfo
      disabled={disabled}
      ids={EnumIds}
      setModalTitle={setModalTitle}
      setShowModal={setShowModal}
      setModalContent={setModalContent}
      brands={brands}
      addBrand={handleOnBrandAdd}
      codesOnChange={handleOnCodeChange}
      deletePopFun={handleOnCodeDelete}
      setData={handleOnInfoChange}
      data={data}
      onTypeChange={handleOnTypeChange}
      productType={productType}
    />
  );
};

const StatusTitle = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const canEdit = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.Products,
        operation: EnumOperation.add_edit_product,
      }),
    ],
  });
  const { form, formName, avaAtt = [] } = props;
  const publishFields = avaAtt.map((i) => {
    const { uuid } = i;
    return ['attributes', uuid];
  });
  const _d = useDispatch();
  const generateProductStatus = (func, status) => {
    changeProductStatus({
      convertDataFromReduxToServer,
      validation,
      getState,
      statusChanges: func,
      status,
      form,
    });
  };

  const getValidatedData = ({ validation, getState, status }) => {
    store.dispatch(validation(status));
    const state = store.getState();
    const data = getState()(state);
    return data;
  };

  const getFormValue = () => {
    const value = form.getFieldsValue();
    return value;
  };

  const handleOnError = (error) => {
    onFinishFailed(formName, error);
    return false;
  };

  const changeProductStatus = ({
    convertDataFromReduxToServer,
    statusChanges,
    validation,
    getState,
    status,
    form,
  }) => {
    const data: any = getValidatedData({ validation, getState, status });
    const dataValid = data.dataValid;
    if (status === EnumStatus.Active) {
      const attError = form.getFieldsError(publishFields);
      const errorItem = attError.find((i) => i.errors.length > 0);
      const hasError = !!errorItem;
      if (hasError) {
        // console.log('errorItem', errorItem);
        const { name = [] } = errorItem;
        const pre = formName + '_';
        const suf = name.join('_');
        const id = pre + suf;

        _d(
          onCollapseChange({
            id: EnumCollapseId.Attributes,
            status: true,
          }),
        );
        setTimeout(() => {
          timeoutScroll(id);
        }, 100);
        return;
      }
      form
        .validateFields(allFields)
        .then(() => {
          if (dataValid && statusChanges) {
            const {
              productGiftCardSetting,
              attributes,
              taxRules,
              taxRulesEnabled,
            } = getFormValue() || {};
            const _data = {
              ...convertDataFromReduxToServer(data),
              productGiftCardSetting,
              attributes,
              taxRules,
              taxRulesEnabled,
            };
            store.dispatch(statusChanges(_data));
          }
        })
        .catch((e) => {
          store.dispatch(
            onCollapseChange({
              id: EnumCollapseId.GiftCardSetting,
              status: true,
            }),
          );
          handleOnError(e);
        });
    } else {
      if (dataValid && statusChanges) {
        const {
          productGiftCardSetting,
          attributes,
          taxRules,
          taxRulesEnabled,
        } = getFormValue() || {};
        const _data = {
          ...convertDataFromReduxToServer(data),
          productGiftCardSetting,
          attributes,
          taxRules,
          taxRulesEnabled,
        };

        store.dispatch(statusChanges(_data));
      }
    }
  };
  const status = useSelector(getStatus());
  const name = getProductName();
  const _p: { uuid: string } = useParams();
  const { uuid } = _p;
  const _isNew = uuid === NEW;

  return (
    <Status
      status={status}
      disabled={!canEdit}
      setArchived={generateProductStatus.bind(
        this,
        archiveProduct,
        EnumStatus.Archived,
      )}
      setActive={generateProductStatus.bind(
        this,
        activeProduct,
        EnumStatus.Active,
      )}
      setDraft={generateProductStatus.bind(
        this,
        draftProduct,
        EnumStatus.Draft,
      )}
      title={
        _isNew ? getI18n('allProducts.addproductset.createnewProduct') : name
      }
    />
  );
};

export default SectionHOC(VirtualInfo, {
  containerClassName: css.containerClassName,
  id: EnumCollapseId.ProductInfo,
  Title: StatusTitle,
  sectionTitleClassName: css.titleContainer,
  getCollapse,
  onCollapseChange,
  cannotCollapse: true,
});
